import React from 'react'
import { SelectDropdownProps } from '../../types'
import './select-dropdown-component.scss'
import { concatClassName } from '../../utils/helpers'
import { ERROR } from '../../utils/message'
import { StatusLabel } from '../StatusLabel'
import { ReportIcon } from '../Icon/icon-component'

const SelectDropdown = ({
  classes,
  list,
  name,
  formId,
  handleChange,
  id,
  errors,
  touched,
  value,
  defaultValue,
  placeholder,
  required,
  dataTestId,
  isDisabled,
}: SelectDropdownProps) => {
  const isError = errors && errors[name] && touched && touched[name]

  return (
    <>
      <div className='select-dropdown-wrapper'>
        <select
          className={` ${concatClassName(classes)}`}
          id={id}
          name={name}
          form={formId}
          value={value}
          data-testid={dataTestId}
          defaultValue={defaultValue}
          required={!!required}
          onChange={(e: any) => handleChange && handleChange(e.target.value)}
          disabled={isDisabled}
        >
          {placeholder && (
            <option key={placeholder} value={''} disabled hidden>
              {placeholder}{' '}
            </option>
          )}
          {list &&
            list.map((data) => {
              return (
                <option key={data.value} value={data.value} disabled={!!data?.disabled}>
                  {data.text}{' '}
                </option>
              )
            })}
        </select>
        {isError && (
          <span className='select-dropdown-icon'>
            <ReportIcon height='20' width='20' type={ERROR} />
          </span>
        )}
      </div>
      {isError && <StatusLabel type={ERROR} variant='basic' text={errors[name]} />}
    </>
  )
}

export { SelectDropdown }
